import { MenuIdInsight } from '@jira/navigation-apps__constants/src/MenuIdInsight.tsx';
import { insightObjectResource } from '@jira/router-resources__servicedesk-cmdb-object/src/insightObjectResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { servicedeskCmdbAssetsObjectRoute } from '@jira/router-routes__servicedesk-cmdb-routes/src/servicedeskCmdbAssetsObjectRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getCmdbResources } from './common/getCmdbResources.tsx';
import { InsightCmdbObjectViewV2, LazyServicedeskCmdbObjectV2 } from './ui/object/index.tsx';
import { AssetsAppRedirect } from './ui/redirect/assets-app-redirect/index.tsx';

export const servicedeskCmdbAssetsObjectRouteEntry: Route = createEntry(
	servicedeskCmdbAssetsObjectRoute,

	() => ({
		group: 'servicedesk',
		layout: globalLayout,
		navigation: { menuId: MenuIdInsight },
		// eslint-disable-next-line no-restricted-syntax
		component: fg('assets_as_an_app_v2') ? AssetsAppRedirect : InsightCmdbObjectViewV2,
		resources: [...getCmdbResources(), insightObjectResource],
		forPaint: [LazyAtlassianNavigation, LazyServicedeskCmdbObjectV2],
		perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
		ufoName: 'service-management.insight-cmdb.object-view-page-load',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
